import React from 'react';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import LoginPage from './pages/Login';
import HomePage from './pages/HomePage';
import TwoFactorAuthPage from './pages/TwoFactorAuthPage';
import CadastroClientes from './pages/CadastroClientes';
import Financeiro from './pages/Financeiro';
import CadastroProdutos from './pages/CadastroProdutos';
import CadastroFuncionarios from './pages/CadastroFuncionarios';
import CadastroFornecedores from './pages/CadastroFornecedores';
import Settings from './pages/Settings';
import Calendar from './pages/Calendar';
import ProtectedRoute from './components/ProtectedRoute';
import GestaoCotacoes from './pages/GestaoCotacoes';
import PublicQuotation from './pages/PublicQuotation';
import MaintenanceLock from './components/MaintenanceLock';

const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/2fa",
    element: <TwoFactorAuthPage />,
  },
  {
    path: "/home",
    element: <ProtectedRoute><HomePage /></ProtectedRoute>,
  },
  {
    path: "/",
    element: <Navigate to="/home" />,
  },
  {
    path: "/clientes",
    element: <ProtectedRoute><CadastroClientes /></ProtectedRoute>,
  },
  {
    path: "/financeiro",
    element: <ProtectedRoute><Financeiro /></ProtectedRoute>,
  },
  {
    path: "/produtos",
    element: <ProtectedRoute><CadastroProdutos /></ProtectedRoute>,
  },
  {
    path: "/funcionarios",
    element: <ProtectedRoute><CadastroFuncionarios /></ProtectedRoute>,
  },
  {
    path: "/fornecedores",
    element: <ProtectedRoute><CadastroFornecedores /></ProtectedRoute>,
  },
  {
    path: "/calendario",
    element: <ProtectedRoute><Calendar /></ProtectedRoute>,
  },
  {
    path: "/settings",
    element: <ProtectedRoute><Settings /></ProtectedRoute>,
  },
  {
    path: "/cotacoes",
    element: <ProtectedRoute><GestaoCotacoes /></ProtectedRoute>,
  },
  {
    path: "/public-quotation/:token",
    element: <PublicQuotation />,
  },
]);

const App = () => {
  return (
    <>
      <MaintenanceLock />
      <RouterProvider router={router} />
    </>
  );
};

export default App;
